import useSecuredApiService from './useSecuredApiService'

const useSiteService = () => {
  const { getApiData, getApiDataWithParams, postApiData } = useSecuredApiService()
  const getPaged = async (params) => {
    return await getApiDataWithParams('/Site/getPaged', params)
  }

  const getById = async (id) => {
    return getApiData('/Site/GetById?id=' + id)
  }

  const getAll = async (id) => {
    return getApiData('/Site/GetAll')
  }

  const create = async (data) => {
    return postApiData('/Site/CreateSiteAndAddress', data)
  }
  return {
    getPaged,
    getById,
    getAll,
    create,
  }
}

export default useSiteService
